// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"bi-z","zenCrossSiteLabel":"ci-z","vrsnlCrossSiteLabel":"di-z"};